import { Inject, Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ObjectActions from './device-command-schedule.actions';
import * as AppActions from '../app/actions';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GeneralApiResponseInterface } from '../../layout/main/main.model';
import { DeviceCommandScheduleInterface } from './device-command-schedule.model';
import { IotDeviceManagementPortalAppState } from '../iotDeviceManagementPortalApp.reducer';
import { Store } from '@ngrx/store';
import { PageFiltersAndSettingsService } from '../../shared/service/page-filters-and-settings/page-filters-and-settings.service';
import {DeleteDeviceCommandSchedule} from "./device-command-schedule.actions";

@Injectable()
export class DeviceCommandScheduleEffects {
  constructor(
    private actions$: Actions<ObjectActions.DeviceCommandScheduleActions>,
    private http: HttpClient,
    private readonly store: Store<IotDeviceManagementPortalAppState>,
    private readonly pageFiltersAndSettings: PageFiltersAndSettingsService,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  private DEVICES_URLS = {
    GET: {
      DEVICE_COMMAND_SCHEDULE: '/device-command',
    },
    DELETE: {
      DEVICE_COMMAND_SCHEDULE: '/device-command',
    },
  };

  @Effect()
  getDeviceCommandSchedules$ = this.actions$.pipe(
    ofType(ObjectActions.DeviceActionTypes.GetDeviceCommandSchedules),
    switchMap((objectData: ObjectActions.GetDeviceCommandSchedules) => {
      this.store.dispatch(new AppActions.ShowLoader());
      const url = `${this.baseUrl}${this.DEVICES_URLS.GET.DEVICE_COMMAND_SCHEDULE}`;
      let params: HttpParams = new HttpParams();

      params = params
        .append('page', String(objectData.query.page))
        .append('limit', String(objectData.query.pageSize || 1000));

      if (objectData.query.order) {
        params = params
          .set('order', `${objectData.query.order}`)
          .set('orderType', `${objectData.query.orderType.toUpperCase()}`);
      }

      if (objectData.query.search !== undefined) {
        params = params.set('searchType', String('deviceCommandScheduleSearch'));
        params = params.set('search', String(objectData.query.search));
      }

      if (objectData.query.startDate) {
        params = params.set('startDate', `${objectData.query.startDate}`).set('endDate', `${objectData.query.endDate}`);
      }

      return this.http
        .get<GeneralApiResponseInterface<DeviceCommandScheduleInterface[]>>(url, {
          params,
        })
        .pipe(
          switchMap((response: GeneralApiResponseInterface<DeviceCommandScheduleInterface[]>) => {
            return of(new ObjectActions.GetDeviceCommandSchedulesCompleted(response['data'], response['total']), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
    }),
  );

  @Effect()
  deleteDeviceCommandSchedule$ = this.actions$.pipe(
    ofType(ObjectActions.DeviceActionTypes.DeleteDeviceCommandSchedule),
    switchMap((objectData: ObjectActions.DeleteDeviceCommandSchedule) => {
      this.store.dispatch(new AppActions.ShowLoader());
      const url = `${this.baseUrl}${this.DEVICES_URLS.DELETE.DEVICE_COMMAND_SCHEDULE}/${objectData.id}`;
      let params: HttpParams = new HttpParams();


      return this.http
        .delete<GeneralApiResponseInterface<DeviceCommandScheduleInterface[]>>(url, {
          params,
        })
        .pipe(
          switchMap((response: GeneralApiResponseInterface<DeviceCommandScheduleInterface[]>) => {
            return of(new ObjectActions.DeleteDeviceCommandScheduleCompleted(objectData.id, response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
    }),
  );

}
